<template>
  <div class="dialog" @click.stop>
    <div class="content-wrapper">
      <div class="content">
        {{ content }}
      </div>
      <div class="operation">
        <button class="text-gray-400" @click.stop="handleCancel">取消</button>
        <button class="confirm" @click.stop="handleConfirm">确定</button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class Dialog extends Vue {
  @Prop({ type: String }) content!: string;

  handleCancel() {
    this.$emit('cancel');
  }
  handleConfirm() {
    this.$emit('confirm');
  }
}
</script>

<style scoped>
.dialog {
  @apply fixed top-0 left-0 w-full h-screen;
  z-index: 100;
  background-color: rgba(0, 0, 0, 0.4);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
}

.content-wrapper {
  @apply relative top-1/2 flex items-center justify-center flex-col max-w-xs min-w-60 mx-auto bg-white rounded-md overflow-hidden;
  transform: translateY(-50%);
}

.content {
  @apply h-20 flex items-center justify-center font-medium text-lg;
}

.operation {
  @apply w-full flex justify-between items-center;
}

.operation button {
  @apply w-full h-12 text-center border;
}

.operation button:last-child {
  border-left-width: 0;
}

.confirm {
  color: #6c48e9;
}
</style>
